import { useEffect, useState } from "react";
import { MapContainer, TileLayer, CircleMarker, Tooltip } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { MapPin, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { AdminHeading, Card } from "@/components/admin/ui";

export default function CityWaitlist() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/admin/waitlist").then((r) => setRows(r.data)).catch((e) => { toast.error(formatApiError(e)); setRows([]); }); }, []);
  const mapped = (rows || []).filter((r) => r.lat != null);
  const max = Math.max(1, ...(rows || []).map((r) => r.count));
  const total = (rows || []).reduce((a, r) => a + r.count, 0);

  return (
    <div data-testid="admin-waitlist">
      <AdminHeading title="City waitlist" subtitle={`"Bring Kindsaver to my city" requests from the contact form · ${total} requests from ${rows?.length || 0} cities`} />
      {rows === null ? <Loader2 className="animate-spin text-[var(--leaf)]" /> : (
        <div className="grid lg:grid-cols-3 gap-5">
          <Card className="lg:col-span-2 overflow-hidden h-[460px]" data-testid="waitlist-map">
            <MapContainer center={[22.5, 79]} zoom={4.4} scrollWheelZoom className="w-full h-full">
              <TileLayer attribution='&copy; OpenStreetMap' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
              {mapped.map((r) => (
                <CircleMarker key={r.city} center={[r.lat, r.lng]} radius={8 + (r.count / max) * 22}
                  pathOptions={{ color: "#1B5E20", fillColor: "#E8A33D", fillOpacity: 0.75, weight: 2 }}>
                  <Tooltip>{r.city}: {r.count} request{r.count > 1 ? "s" : ""}</Tooltip>
                </CircleMarker>
              ))}
            </MapContainer>
          </Card>
          <Card className="p-2 max-h-[460px] overflow-y-auto" data-testid="waitlist-list">
            {rows.length === 0 && <div className="p-6 text-sm text-[var(--ink-soft)] text-center" data-testid="waitlist-empty">No city requests yet.</div>}
            {rows.map((r, i) => (
              <div key={r.city} className="flex items-center gap-3 px-3 py-2.5 rounded-xl hover:bg-[var(--paper)]" data-testid={`waitlist-row-${i}`}>
                <span className="w-7 text-xs font-bold text-[var(--ink-soft)]">#{i + 1}</span>
                <MapPin size={15} className={r.lat != null ? "text-[var(--leaf)]" : "text-[var(--ink-soft)]"} />
                <div className="flex-1 min-w-0">
                  <div className="font-semibold truncate">{r.city}</div>
                  <div className="h-1.5 mt-1 rounded-full bg-[var(--paper-2)] overflow-hidden"><div className="h-full bg-[var(--marigold)]" style={{ width: `${(r.count / max) * 100}%` }} /></div>
                </div>
                <span className="font-display font-bold text-lg">{r.count}</span>
              </div>
            ))}
          </Card>
        </div>
      )}
    </div>
  );
}
